export const ORGANIZATION_NAME = 'Пак Пакыч';
